<template>
  <div class="segment-custom-opt-wrap">
    <v-select
      v-model="parentModel"
      variant="outlined"
      density="compact"
      persistentPlaceholder
      hideDetails
      :items="parentItems"
      itemTitle="name"
      :disabled="disabled"
      itemValue="label"
      placeholder="Select configuration"
      class="segment-builder--subtypes _subtypes"
      bgColor="#ffffff"
      style="min-width: 180px"
      :menuProps="{ maxHeight: 410, offsetY: true, minWidth: 240 }"
      @update:modelValue="updateParent"
    />
    <div v-if="parentModel" class="segment-builder--item next-selection min-w-px">
      <RfChevronIcon class="fill-beige-50 mx-1 my-auto h-6 w-6 rotate-180" />
      <div class="flex flex-col gap-2 overflow-auto">
        <RfCustomControls
          v-for="(childFilterItem, index) in childFilter"
          :key="`${upkey}-${childFilterItem.id}`"
          :isLastControl="index === childFilter.length - 1"
          :modelValue="childModel"
          :values="childFilterItem.values"
          :disabled="disabled"
          :currentOptions="childFilterItem.options"
          @update="(...e) => updateFilter(...e, index)"
          @deleteRow="deleteRow(index)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RfCustomControls from "@/components/RfCustomControls.vue";
import { getCustomFiltersData } from "@/utils/segmentsHelpers";
import { useCustomFields } from "@/utils/composables/useCustomFields";
import RfChevronIcon from "../icons/RfChevronIcon.vue";
import { useAppsStore } from "@/pinia/appsStore";

export default {
  name: "RfCustom",
  components: { RfCustomControls, RfChevronIcon },
  props: { filter: Object, disabled: [Boolean, String], isPinpoint: Boolean, selected: Array },
  setup: () => ({ customFields: useCustomFields(), appsStore: useAppsStore() }),
  data: () => ({ parentModel: null, upkey: 0 }),
  computed: {
    filterFunc() {
      if (this.isPinpoint) {
        return ({ data_type }) => ["boolean", "string"].includes(data_type);
      }

      if (this.appsStore?.app?.flags?.complex_collection) {
        return () => true;
      }

      return ({ data_type }) => !["complex_collection"].includes(data_type);
    },
    selectedWithoutParent() {
      return this.selected.filter(el => el !== this.parentModel);
    },
    parentItems() {
      return getCustomFiltersData(this.customFields.appCustomFields.value)
        .filter(this.filterFunc)
        .filter(item => !this.selectedWithoutParent.includes(item.label));
    },
    childModel() {
      return this.parentItems.find(parent => parent.label === this.parentModel);
    },
    childFilter() {
      return this.filter.custom[this.childModel.label] || {};
    },
    customKey() {
      return Object.keys(this.filter.custom)[0];
    },
  },
  mounted() {
    this.prepareFilter();
  },
  methods: {
    deleteRow(index) {
      this.incrKey();
      const filter = { custom: { [this.childModel.label]: [] } };
      this.childFilter.forEach((item, i) => {
        if (i !== index) {
          filter.custom[this.childModel.label].push(item);
        }
      });
      this.$emit("update:model", filter);
    },
    updateParent() {
      this.incrKey();
      this.updateFilter([], {});
    },
    updateFilter(values, options, index) {
      if (index !== undefined) {
        const filter = { custom: { [this.childModel.label]: [] } };
        this.childFilter.forEach((item, i) => {
          if (i === index) {
            filter.custom[this.childModel.label].push({ values, options });
          } else {
            filter.custom[this.childModel.label].push(item);
          }
        });
        this.addNewRowToChildFilter(filter);
        return;
      }
      const filter = { custom: { [this.childModel.label]: [{ values, options }] } };

      this.$emit("update:model", filter);
    },
    addNewRowToChildFilter(incomingFilter) {
      if (!this.childModel) return;
      const filter = incomingFilter || {
        custom: { [this.childModel.label]: [...this.childFilter] },
      };
      const lastFilter = this.childFilter[this.childFilter.length - 1];
      if (lastFilter.values.length > 0 || Object.keys(lastFilter.options || {}).length > 0) {
        filter.custom[this.childModel.label].push({ values: [], options: {} });
      }
      this.$emit("update:model", filter);
    },
    prepareFilter() {
      this.parentModel = this.customKey;
      this.addNewRowToChildFilter();
    },
    incrKey() {
      this.upkey += Math.random();
    },
  },
};
</script>
